import React, { useContext } from 'react';

import { useSetupTheme } from './useSetupTheme';

type ThemeContextProps = {
  children: React.ReactNode;
};

type ThemeContextValue = {
  theme: ThemeType;
  onToggle: () => void;
  onChange: (newTheme: ThemeType) => void;
};

const ThemeContext = React.createContext<ThemeContextValue>({
  theme: 'light',
  onToggle: () => {},
  onChange: () => {},
});

const ThemeProvider: React.FC<ThemeContextProps> = ({ children }) => {
  const value = useSetupTheme();

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export default React.memo(ThemeProvider);
export const useTheme = () => useContext(ThemeContext);
